module.exports = __webpack_public_path__ + "img/winerack31.5fc87163.jpg";